
async function refreshCartDrawer() {
  const root = window.Shopify?.routes?.root || '/';
  const cart = document.querySelector('mini-cart');

  if (!cart || typeof cart.renderContents !== 'function') {
    throw new Error('Winkelwagen kan niet worden vernieuwd.');
  }

  const sectionIds = cart.getSectionsToRender().map(
    section => section.section
  );

  const response = await fetch(
    root + '?sections=' + sectionIds.join(',')
  );

  if (!response.ok) {
    throw new Error('Winkelwagen kon niet worden opgehaald.');
  }

  const sections = await response.json();

  if (sectionIds.some(id => !sections[id])) {
    throw new Error('Niet alle winkelwagenonderdelen zijn geladen.');
  }

  cart.renderContents({ sections });
}

document.addEventListener('click', async function (event) {
  const button = event.target.closest(
    '#mini-cart-discount-apply, #cart-page-discount-apply'
  );

  if (!button) return;

  const container = button.closest(
    '.mini-cart-discount, .cart-page-discount'
  );

  if (!container) return;

  const input = container.querySelector('input');
  const message = container.querySelector('[role="status"]');

  const code = input.value.trim();

  if (!code) {
    message.textContent = 'Vul eerst een kortingscode in.';
    return;
  }

  button.disabled = true;
  button.textContent = 'Momentje...';
  message.textContent = '';

  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: code
      })
    });

    if (!response.ok) {
      throw new Error('Kortingscode kon niet worden verwerkt.');
    }

   // Vernieuw de winkelwagen zonder de pagina te herladen.
if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
  window.location.reload();
} else {
  await refreshCartDrawer();
}

  } catch (error) {
    message.textContent =
      'Er ging iets mis. Probeer het opnieuw.';

    button.disabled = false;
    button.textContent = 'Toepassen';
  }
});

document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-remove-discount]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });

    if (!response.ok) {
      throw new Error('Verwijderen mislukt');
    }

    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
  window.location.reload();
} else {
  await refreshCartDrawer();
}
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    alert('De kortingscode kon niet worden verwijderd. Probeer het opnieuw.');
  }
});
